/**
 * 管理员中心页面
 *
 * 包含侧边栏（导航）和内容区（slot 渲染）。
 * 通过 URL query param `?section=xxx` 控制当前激活的 section。
 *
 * 内置"仪表盘"section，第三方通过 IAdminSlotsService 注册的 slot
 * 也会在此页面的侧边栏和内容区展示。
 */
import * as React from 'react';
import { useRoute } from '@hvsin/mod-route';
import { DASHBOARD_SECTION_ID } from '@hvsin/admin-contracts';
import { Sidebar } from '../components/sidebar.js';
import { DashboardPanel } from '../components/dashboard-panel.js';
/**
 * 管理员中心页面
 */
export function AdminPage({ slotsService }) {
    const [slots, setSlots] = React.useState(() => slotsService.getSlots());
    const { useSearchParams } = useRoute();
    const [searchParams] = useSearchParams();
    const activeSection = searchParams.get('section') || DASHBOARD_SECTION_ID;
    // 订阅 slot 变化，触发重渲染
    React.useEffect(() => {
        const unsubscribe = slotsService.subscribe(() => {
            setSlots(slotsService.getSlots());
        });
        return unsubscribe;
    }, [slotsService]);
    // 根据 activeSection 决定渲染内容
    const renderContent = () => {
        if (activeSection === DASHBOARD_SECTION_ID) {
            return React.createElement(DashboardPanel, {});
        }
        const slot = slots.find(s => s.id === activeSection);
        if (slot) {
            return React.createElement(slot.component, {});
        }
        // 未找到有效 section，fallback 到 dashboard
        return React.createElement(DashboardPanel, {});
    };
    return React.createElement('div', { className: 'admin-container', style: styles.container }, React.createElement(Sidebar, { slots }), React.createElement('main', { className: 'admin-content', style: styles.content }, renderContent()));
}
const styles = {
    container: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
    },
    content: {
        flex: 1,
        overflowY: 'auto',
    },
};
//# sourceMappingURL=admin-page.js.map